import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxCaptureModule } from 'ngx-capture';
import { ScreenshotOverlayComponent } from './screenshot-overlay.component';
import { ScreenshotToolbarComponent } from './screenshot-toolbar.component';

/**
 * Global screenshot infrastructure. Import this module once in AppModule and
 * drop <app-screenshot-overlay data-screenshot-ignore></app-screenshot-overlay>
 * near the router-outlet in app.component.html. Anywhere else in the app can
 * inject ScreenshotService (providedIn: 'root') to start a capture.
 */
@NgModule({
  declarations: [ScreenshotOverlayComponent, ScreenshotToolbarComponent],
  imports: [CommonModule, MatIconModule, MatDialogModule, NgxCaptureModule],
  exports: [ScreenshotOverlayComponent],
})
export class GlobalScreenshotModule {}
